import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import AppLayout from './layouts/AppLayout.vue'
import AppLayoutStagingBar from './layouts/AppLayoutStagingBar.vue'
import { ENV } from '@/common/config'
import ToastNotificationsVue from './notifications/ToastNotificationsVue.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isStaging = ENV === 'dev'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppLayout),
    _createVNode(ToastNotificationsVue),
    isStaging
      ? (_openBlock(), _createBlock(AppLayoutStagingBar, { key: 0 }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})